import type { ReactNode } from 'react';

import type { THeadingElement } from '@shared/dream-components';
import {
  Heading1Element,
  Heading2Element,
  Heading3Element,
  Heading4Element,
  Heading5Element,
  Heading6Element,
} from '@shared/dream-components';

import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

// text replacement is handled in utils/processMergeTag

interface Props {
  node: THeadingElement;
  children: ReactNode | ReactNode[];
}

type HeadingComponent = typeof Heading1Element;
type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

const Heading = ({ node, children }: Props) => {
  const { children: childrenToRender } = useProductMergeTagProcessor({ node, children });

  const HComp: Record<HeadingLevel, HeadingComponent> = {
    1: Heading1Element,
    2: Heading2Element,
    3: Heading3Element,
    4: Heading4Element,
    5: Heading5Element,
    6: Heading6Element,
  };

  const Component = HComp[node.attrs.level as HeadingLevel];

  return <Component element={node}>{childrenToRender}</Component>;
};

export default Heading;
